module.exports = __webpack_public_path__ + "img/new-house-1-min.dfd9e191.png";